import { combineReducers } from 'redux';
import { createLoadingReducer } from './utils';

export const settings = createLoadingReducer('BILLMATE_API_SETTINGS');
export const test = createLoadingReducer('TEST_BILLMATE_API_SETTINGS');

export default combineReducers({ settings, test });
